<template>
  <cost-prices-additional-fee-detail
    ref="costPricesAdditionalFeeDetail"
    type="edit"
    :submitting="submitting"
    :values="data"
    @submit="submit"
  />
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import CostPricesAdditionalFeeDetail from './CostPricesAdditionalFeeDetail.vue';

export default {
  components: {
    CostPricesAdditionalFeeDetail
  },
  mixins: [helper],
  data() {
    return {
      submitting: false,
      data: {}
    };
  },

  created() {
    const providerId = this.$route.params.providerId;
    const feeId = this.$route.params.feeId;
    this.getFeeData(providerId, feeId);
  },
  methods: {
    submit(data) {
      const request = {};

      const id = data.providerId;

      request.description = data.description;
      request.price = data.price;
      request.pricingType = data.pricingType;
      request.status = data.status;

      const feeId = this.$route.params.feeId;

      this.submitting = true;
      useService
        .editProviderFee(id, feeId, request)
        .then(response => {
          this.showSuccessMessage(`${response.message}`);
          this.$router.push({
            name: 'cost-prices-additional-fees'
          });
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    getFeeData(providerId, feeId) {
      this.submitting = true;
      useService
        .getFee(providerId, feeId)
        .then(response => {
          this.data = response.data;

          const { description, price, pricingType, status, provider } = response.data;

          this.data = {
            description,
            price,
            pricingType,
            status,
            providerId: Number(providerId),
            provider
          };
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
